import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { WorkoutRetrieve } from 'types';
import { client } from 'utils/api-client';

interface UseClassWorkoutDetailsParams {
  kiloClassId: string | undefined;
}

function useClassWorkoutDetails({
  kiloClassId,
}: UseClassWorkoutDetailsParams): UseQueryResult<AxiosResponse<WorkoutRetrieve | undefined>> {
  return useQuery(
    ['workouts', 'details', kiloClassId],
    () => client.get<WorkoutRetrieve>(`workouts/details/?kilo_class=${kiloClassId}&limit=1`),
    {
      enabled: !!kiloClassId,
    },
  );
}

export default useClassWorkoutDetails;
